module.exports = __webpack_public_path__ + "img/mrv.9acc11d2.svg";